import React, { SVGAttributes } from 'react'

export const Share: React.FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.2 19.2C13.2 20.2756 14.4888 20.7871 15.2286 20.069L15.3218 19.9683L21.3218 12.7683C21.659 12.3637 21.6896 11.7927 21.4138 11.3579L21.3218 11.2318L15.3218 4.03183C14.6333 3.20553 13.3157 3.63773 13.2071 4.66301L13.2 4.80005V8.40005C7.34181 8.40005 2.57303 13.0642 2.40458 18.8816L2.39998 19.2C5.38589 16.9606 8.99068 15.7072 12.7137 15.6066L13.2 15.6V19.2Z"
    />
  </svg>
)
